module.exports = __webpack_public_path__ + "d4c0b303/img/comment-icon.2a1812af.svg";